import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable, NgModule } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { DialogService } from "./services/dialog.service";
import { LoaderService } from "./services/loader.service";

@Injectable()
export class HttpsRequestInterceptor implements HttpInterceptor {
  constructor(
    private loaderService: LoaderService,
    private dialogService: DialogService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    setTimeout(() => {
      this.loaderService.addLoader();
    }, 0);

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          this.loaderService.removeLoader();
        },
        (err: any) => {
          this.loaderService.removeLoader();

          if (err.status === 403 && !err.url.includes("security/auth")) {
            this.dialogService.inform(
              "Permissão negada",
              "Você não possui a permissão necessária para executar esta ação. Entre em contato com o administrador para mais informações."
            );
          }
        }
      )
    );
  }
}

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
    },
  ],
})
export class Interceptor {}
